function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1440_-HOMEPAGE-next",
  transform: "translate(-1283.000000, -70.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu",
  transform: "translate(40.000000, 32.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_notification-icon_notification_16",
  transform: "translate(1242.000000, 38.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.95961538,14.2222222 L10.625,14.2222222 C10.2211538,15.2727273 9.21153846,16 8,16 C6.82884615,16 5.77884615,15.2727273 5.375,14.2222222 L7.95961538,14.2222222 Z M14.3069392,11.0144928 C11.6031439,9.52898551 13.4807795,5.10869565 11.7909075,2.82608696 C11.1149587,1.92028986 10.1761409,1.37681159 9.12466493,1.19565217 L9.12466493,1.08695652 C9.12466493,0.507246377 8.63647967,0 7.99808357,0 L7.99808357,0 C7.39724017,0 6.87150221,0.471014493 6.87150221,1.08695652 L6.87150221,1.19565217 C5.82002627,1.41304348 4.84365575,1.95652174 4.20525965,2.82608696 C2.51538761,5.10869565 4.39302321,9.52898551 1.68922794,11.0144928 C0.712857426,11.5217391 0.750410138,13.2246377 1.95209692,13.3333333 L7.99808357,13.3333333 L7.99808357,13.3333333 L8.03563628,13.3333333 L14.0816229,13.3333333 C15.245757,13.2246377 15.2833097,11.557971 14.3069392,11.0144928 Z",
  id: "Shape"
})))));

var SvgIconNotificationIconNotification162X = function SvgIconNotificationIconNotification162X(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconNotificationIconNotification162X, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_notification-icon_notification_16@2x.c936a679.svg";
export { ForwardRef as ReactComponent };